import styled from "styled-components";

const Form = styled.form`
  display: grid;
  gap: 30px 0;
`;

export { Form };
